// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  runId: __t.string().name("run_id"),
  sourceName: __t.string().name("source_name"),
  fingerprint: __t.string(),
  specHash: __t.string().name("spec_hash"),
  startedBy: __t.identity().name("started_by"),
  recordedAt: __t.timestamp().name("recorded_at"),
  durationMs: __t.u32().name("duration_ms"),
  models: __t.u32(),
  twinsCreated: __t.u32().name("twins_created"),
  twinsUpdated: __t.u32().name("twins_updated"),
  relationships: __t.u32(),
  status: __t.string(),
  createdIdsJson: __t.string().name("created_ids_json"),
  createdIdsTruncated: __t.bool().name("created_ids_truncated"),
  undoDeleted: __t.u32().name("undo_deleted"),
  undoSkipped: __t.u32().name("undo_skipped"),
});
